import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100",
  height: "100",
  viewBox: "0 0 48 48"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#212121",
  "fill-rule": "evenodd",
  d: "M10.904 6h26.191A4.905 4.905 0 0 1 42 10.904v26.191A4.905 4.905 0 0 1 37.096 42H10.904A4.905 4.905 0 0 1 6 37.096V10.904A4.905 4.905 0 0 1 10.904 6",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#ec407a",
  "fill-rule": "evenodd",
  d: "M29.208 20.607a9.6 9.6 0 0 0 5.592 1.788v-4.011q-.594 0-1.174-.123v3.157a9.6 9.6 0 0 1-5.592-1.788v8.184a7.415 7.415 0 0 1-7.417 7.413 7.4 7.4 0 0 1-4.129-1.254 7.4 7.4 0 0 0 5.303 2.23 7.415 7.415 0 0 0 7.417-7.413zm1.449-4.046a5.6 5.6 0 0 1-1.449-3.273v-.516h-1.113a5.62 5.62 0 0 0 2.562 3.789M19.079 30.832a3.392 3.392 0 0 1 3.73-5.285v-4.1a7.6 7.6 0 0 0-1.174-.068v3.191a3.392 3.392 0 0 0-2.556 6.262",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M28.034 19.63a9.6 9.6 0 0 0 5.592 1.788v-3.157a5.62 5.62 0 0 1-2.969-1.701 5.61 5.61 0 0 1-2.561-3.788h-2.923V28.79a3.392 3.392 0 0 1-6.094 2.041 3.39 3.39 0 0 1 1.527-6.42c.359 0 .705.056 1.03.159v-3.19a7.414 7.414 0 0 0-5.146 12.594 7.4 7.4 0 0 0 4.129 1.254 7.415 7.415 0 0 0 7.417-7.413z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#81d4fa",
  "fill-rule": "evenodd",
  d: "M33.626 18.262v-.854a5.6 5.6 0 0 1-2.969-.848 5.6 5.6 0 0 0 2.969 1.702m-5.531-5.49a6 6 0 0 1-.061-.461v-.516h-4.036v16.019a3.392 3.392 0 0 1-4.919 3.017 3.392 3.392 0 0 0 6.094-2.041V12.772zm-6.46 8.608v-.909a7.415 7.415 0 0 0-5.147 13.503 7.38 7.38 0 0 1-2.114-5.183 7.415 7.415 0 0 1 7.261-7.411",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }